import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Icon from 'components/DesignSystem/Icon';
import ThemeSwitcher from 'components/ThemeSwitcher';
import { selectTokenUserName, selectUserIsAdmin } from 'redux/reducers/authReducer';
import featureFlags from 'constants/featureFlags';
import logout from 'utils/logout';

import './index.scss';

export default function MoreSheet({ open, dismiss }: { open: boolean; dismiss: () => void }) {
  const navigate = useNavigate();
  const admin = useSelector(selectUserIsAdmin);
  const userName = useSelector(selectTokenUserName);

  const goTo = (path: string) => {
    dismiss();
    navigate(path);
  };

  const onLogout = () => {
    dismiss();
    logout(navigate, { title: '', message: 'Logout realizado com sucesso.', variant: 'success' });
  };

  return (
    <BottomSheet open={open} dismiss={dismiss} title="Mais">
      <ul className="more-sheet-list list-unstyled mb-0">
        {featureFlags.windx && (
          <li>
            <button type="button" className="more-sheet-item" onClick={() => goTo('/windx')}>
              <Icon iconType="wind" color="currentColor" />
              <span className="more-sheet-label">Windx</span>
              <Icon iconType="right_arrow" color="currentColor" className="more-sheet-chevron" />
            </button>
          </li>
        )}
        {featureFlags.relatorios && (
          <li>
            <button type="button" className="more-sheet-item" onClick={() => goTo('/relatorios')}>
              <Icon iconType="line_axis" color="currentColor" />
              <span className="more-sheet-label">Relatórios</span>
              <Icon iconType="right_arrow" color="currentColor" className="more-sheet-chevron" />
            </button>
          </li>
        )}
        {admin && (
          <li>
            <button type="button" className="more-sheet-item" onClick={() => goTo('/admin')}>
              <Icon iconType="admin" color="currentColor" />
              <span className="more-sheet-label">Administração</span>
              <Icon iconType="right_arrow" color="currentColor" className="more-sheet-chevron" />
            </button>
          </li>
        )}
        <li className="more-sheet-appearance">
          <div className="more-sheet-appearance-label">Aparência</div>
          <ThemeSwitcher variant="labeled" />
        </li>
        <li className="more-sheet-account">{userName}</li>
        <li>
          <button type="button" className="more-sheet-item more-sheet-logout" onClick={onLogout}>
            <span className="more-sheet-label">Sair</span>
          </button>
        </li>
      </ul>
    </BottomSheet>
  );
}
